import styled from "styled-components/macro";

import FnrCloseButton from "UI/FnrCloseButton/FnrCloseButton";
import FnrMovingDiv from "UI/FnrMovingDiv/FnrMovingDiv";
import FnrOverlay from "UI/FnrOverlay/FnrOverlay";

export default function FieldEditorOverlay({ close, show, children }) {
  return (
    <FnrOverlay show={show}>
      <CloseButtonContainer>
        <FnrCloseButton onClick={close} legacy />
      </CloseButtonContainer>
      <Container>
        <FieldsContainer>
          <FnrMovingDiv heightMotion>{children}</FnrMovingDiv>
        </FieldsContainer>
      </Container>
    </FnrOverlay>
  );
}

const Container = styled("div")`
  width: min(560px, calc(100vw - 40px));
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  overflow: auto;
  border-radius: 14px;
`;
const FieldsContainer = styled("div")`
  width: 100%;
  max-height: min(800px, calc(100vh - 40px));
  overflow-y: auto;
  overflow-x: hidden;
`;
const CloseButtonContainer = styled.div`
  margin: -8px;
  position: absolute;
`;
